import { X } from 'lucide-react';
import { HelpTooltip } from '../../components/common/HelpTooltip';
import { FontPicker } from '../../features/videoEditor/components/FontPicker';

/** 「利用できる書体」のヘルプ文 (欄の見出しの右に出すとき用に書き出す) */
export const BRAND_FONT_HELP = 'Google Fontsからブランドの雰囲気に近いフォントを選んでください。動画エディターではテロップのフォントとして優先して利用されます。静止画の生成では書体の参考にされます。複数選択可能です。';

interface BrandFontFieldProps {
  value: string[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
  /** フォント選択の右にヘルプを出す (見出しの右に出すときは false・2026-10-30) */
  showHelp?: boolean;
}

export function BrandFontField({ value, onChange, disabled = false, showHelp = true }: BrandFontFieldProps) {
  return (
    <fieldset disabled={disabled} className="brand-font-field" aria-label="ブランドフォント">
      <div className="brand-font-controls">
        <div className="brand-font-select">
          <FontPicker
            family="" weight={400} familyOnly disabled={disabled} selectedFamilies={value}
            onChange={({ fontFamily }) => onChange(value.includes(fontFamily)
              ? value.filter((font) => font !== fontFamily) : [...value, fontFamily])}
          />
          {showHelp && (
            <HelpTooltip ariaLabel="ブランドフォントのヘルプ">
              {BRAND_FONT_HELP}
            </HelpTooltip>
          )}
        </div>
        {value.length > 0 && <button type="button" className="btn-text-secondary" onClick={() => onChange([])}>すべて解除</button>}
      </div>
      {value.length === 0 ? <p className="inline-edit-hint">未設定</p> : (
        <ul className="brand-font-list">
          {value.map((font) => (
            <li key={font} className="brand-font-item">
              {font} <button type="button" className="brand-font-remove" aria-label={`${font}を解除`} title={`${font}を解除`}
                onClick={() => onChange(value.filter((item) => item !== font))}><X size={14} aria-hidden="true" /></button>
            </li>
          ))}
        </ul>
      )}
    </fieldset>
  );
}
